import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Hook to detect page changes

const MessengerButton = () => {
  const [showBubble, setShowBubble] = useState(true);
  const location = useLocation(); // This updates whenever the URL changes

  useEffect(() => {
    setShowBubble(true); // Show bubble when page changes
    
    const timer = setTimeout(() => {
      setShowBubble(false);
    }, 10000); // 10 seconds

    return () => clearTimeout(timer); // Cleanup timer if user leaves page fast
  }, [location]); // Dependency array: triggers every time the route changes

  return (
    <div className="messenger-container">
      {showBubble && (
        <div className="messenger-bubble">
          Send us a message!
        </div>
      )}
      <a 
        href="https://m.me/jcilucenachapter"
        className="messenger-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/b/be/Facebook_Messenger_logo_2020.svg" 
          alt="Chat" 
        />
      </a>
    </div>
  );
};

export default MessengerButton;